import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';

interface Message {
  created: string;
  id: number;
  modified: string;
  person: string;
  value: string;
}

@Component({
  selector: 'app-messenger-drawer',
  templateUrl: './messenger-drawer.component.html',
})
export class MessengerDrawerComponent implements OnInit, AfterViewInit {
  @Input() messages: Observable<Message[]>;
  @Input() isDrawer: boolean = false;

  constructor() {}

  ngOnInit(): void {
    console.log('MessengerDrawerComponent initialized', { messages: this.messages, isDrawer: this.isDrawer });
  }

  ngAfterViewInit(): void {
    console.log('MessengerDrawerComponent view initialized');
  }
}
